import { strings } from "intl/fa";
import React from "react";
import Header, { NavType } from "../../commons/header/Header";
import Wrapper from "../../commons/wrapper/Wrapper";
import ProfileInputsCard from "./ProfileInputsCard";
import { AccountType } from "../../../core/auth/auth.entity";

interface Props {
  userType: AccountType;
}

const Profile: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <Wrapper>
      <Header
        navType={NavType.both}
        title={strings.profile.title}
        userType={props.userType}
      />
      <ProfileInputsCard
        userType={props.userType}
        buttonText={strings.common.button.save}
      />
    </Wrapper>
  );
};

export default Profile;
